import { createContext } from 'react';
export const BottomSheetModalInternalContext = /*#__PURE__*/createContext(null);
export const BottomSheetModalInternalProvider = BottomSheetModalInternalContext.Provider;
//# sourceMappingURL=internal.js.map